import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from '../service/frappe/auth.service';
import { NavigationExtras, Router } from '@angular/router';
import { VendorTsService } from '../service/vendor/vendor.ts.service';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {

    loggedInUser: string = '';
    vendorCode: string = '';
    searchResponse: any[] = [];
    clickResponse: any[] =[];
    searchQuery: string = '';
    items!: MenuItem[];
    visible: boolean = false;
    sidebarVisible: boolean = false
    selectedItem: any;
    userMenuVisible: boolean = false;
    role:string=''

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private router: Router,
        private elementRef: ElementRef,
        private vendorService: VendorTsService
    ) { }

    ngOnInit() {
      this.vendorService.checkIfVendor()
      .then((response) => {
        if (response.message.is_administrator) {
          this.role = "Administrator"
        }else if (response.message.isGateKeeper) {
          this.role= "Gate Keeper"
        }else if (response.message.isVendor) {
          this.role = response.message.vendorName
        }
        else if (response.message.isVendorAdmin) {
          this.role = "Vendor Admin"
        }
        else if (response.message.is_new_role) {
          this.role = response.message.is_new_role
        }
        else if (response.message.isVendorSuperAdmin) {
          this.role = "Vendor Super Admin"
        }else if (response.message.is_vendor_auditor) {
          this.role = "Vendor Auditor"
        }else{
          this.role = ''
        }
        // this.isVendor = response.message.roles.includes("Vendor")
      }).catch((error) => {
        console.log(error)
      });
        // this.items = [
        //     {
        //         label:'',
        //         icon: 'pi pi-fw pi-user',
        //         items: [
        //             {
        //                 label: 'Profile',
        //                 icon: 'pi pi-fw pi-user-edit',
        //                 routerLink: '/portal/vendor/vendor-detail-by-id'
        //             },
        //             {
        //                 label: 'Logout',
        //                 icon: 'pi pi-fw pi-sign-out',
        //                 command:(click)=>{this.logout()}
        //             }
        //         ]
        //     }
        // ];

        this.authService.getLoggedInUser().then(username => {
            // this.loggedInUser = username;
            if (username) {
                this.authService.getVendorCode(username).then(response => {
                  if (response.message.length > 0) {
                    const firstMessage = response.message[0];
                    this.vendorCode = firstMessage.vendor_code || firstMessage.business_email || username;
                  }else{
                    this.vendorCode = username
                  }
                }).catch(error => {
                    this.vendorCode = '';
                });
            }
        });
    }

    toggleUserMenu() {
        this.userMenuVisible = !this.userMenuVisible;
    }

    navigateToProfile() {
        this.router.navigate(['profile']);
        this.userMenuVisible = false;
    }

    logout() {
        localStorage.removeItem('userFound');
        this.authService.logout()
            .then(() => {
                this.router.navigate(['auth/login']);
            })
            .catch((error) => console.error(error));;
    }

    openModal() {
        this.visible = true;
        if (this.searchQuery.trim() !== '') {
            this.authService.getSearch(this.searchQuery).then(searchResponse => {
                this.searchResponse = searchResponse;
                this.processSearchResults(searchResponse.message);
            }).catch(error => {
                console.error('Error occurred while performing search:', error);
            });
        } else {
            console.warn('Empty search text!');
        }
    }

    processSearchResults(results: any[]) {
        const itemValues: any[] = [];
        results.forEach((item: any) => {
            if (item.doctype === 'Purchase Order') {
                itemValues.push({ name: item.poagreement_no, doctype: 'PO-Agreement No' });
            }
            if(item.doctype === 'IR'){
                itemValues.push({ name: item.ir_no, doctype: 'Ir No' });
            }
            if(item.doctype === 'GR'){
                itemValues.push({ name: item.gr_no, doctype: 'Gr No' });
            }
            if(item.doctype === 'Schedule For Shipment'){
                itemValues.push({ name: item.item_no, doctype: 'Item No' });
            }
            if(item.doctype === 'Shipment ASN'){
                itemValues.push({ name: item.name, doctype: 'Shipment ASN' });
            }
        });
        this.searchResponse = itemValues;
    }

    closeModal() {
        this.visible = false;
    }


    handleItemClick(item: any) {
        this.selectedItem = item;
        if (this.selectedItem) {
            const routeMap: any = {
                'PO-Agreement No': '/view-purchase-order',
                'Ir No': '/ir',
                'Gr No': '/gr',
                'Item No': '/portal/order/schedule',
                'Shipment ASN': '/portal/order/shipment'
            };

            const route = routeMap[this.selectedItem.doctype];
            if (route) {
                const navigationExtras: NavigationExtras = {
                    state: {
                      selectedNo: this.selectedItem.name
                    }
                  };
                this.router.navigate([route],navigationExtras);
                this.visible = false;
            }
        }
    }


    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
        this.userMenuVisible = false;
        }
    }

    onWindowClick(event: Event) {
        const modal = document.getElementById('myModal');
        if (event.target === modal) {
          this.closeModal();
        }
    }
}
